import { render, staticRenderFns } from "./MainAI.vue?vue&type=template&id=b45ff3c0&"
import script from "./MainAI.vue?vue&type=script&lang=js&"
export * from "./MainAI.vue?vue&type=script&lang=js&"
import style0 from "./MainAI.vue?vue&type=style&index=0&id=b45ff3c0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports